import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { DesktopOnly } from "@utils/MediaQuery"
import React from "react"
import styled from "styled-components"

import Item, { ItemProps } from "./Item"

const Container = styled.div`
  border-bottom: solid 1px ${colors.dividerLineGray};
  background-color: ${colors.backgroundGray30};

  @media ${breakpoints.laptop} {
    flex-direction: column;
    flex-grow: 1;
    display: flex;
    overflow: hidden;
    overflow-y: auto;
    height: 100%;
    padding: 18px 64px 0;
    border-bottom: none;
    background-color: transparent;
  }
`

const DividerWrapper = styled.div`
  width: 100%;
  padding: 0 16px;

  @media ${breakpoints.tablet} {
    padding: 0 24px;
  }

  @media ${breakpoints.laptop} {
    padding: 0;
  }
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.dividerLineGray};
`

interface BodyProps {
  items: Array<ItemProps>
}

const Body: React.FC<BodyProps> = ({ items }) => {
  return (
    <Container>
      {items.map((item, i) => (
        <React.Fragment key={i}>
          <Item {...item} />
          {i !== items.length - 1 && (
            <DividerWrapper>
              <Divider />
            </DividerWrapper>
          )}
        </React.Fragment>
      ))}
      <DesktopOnly>
        <DividerWrapper>
          <Divider />
        </DividerWrapper>
      </DesktopOnly>
    </Container>
  )
}

export default Body
